<script setup lang="ts">
import PipedriveUserPicture from '@components/PipedriveUserPicture.vue';
import type { WithPictureUrlPipedriveUser } from '@models/interfaces/withPictureUrlPipedriveUser';
import { computed } from 'vue';
import Icon from '@components/Icon.vue';
import { type IconProps } from '@global-types/icon';

interface Props {
  title?: string;
  content?: string;
  contentList?: string[];
  accountManager?: WithPictureUrlPipedriveUser;
  icon?: IconProps['svg'];
  type?: string;
}

const {
  title = '',
  content = '',
  contentList = [],
  accountManager = undefined,
  icon = undefined,
  type = '',
} = defineProps<Props>();

const panelType = computed<string>(() => (type !== '' ? `panel--${type}` : ''));
</script>

<template>
  <div class="panel" :class="panelType">
    <div class="panel__picture">
      <PipedriveUserPicture
        v-if="accountManager && accountManager.picture_url"
        :pipedrive-user="accountManager"
      />
      <Icon
        v-if="icon"
        :svg="icon"
        class="panel__icon"
      />
    </div>
    <div class="panel-content panel__content">
      <div
        v-if="title"
        class="panel-content__title"
      >
        {{ title }}
      </div>
      <div v-if="content" class="panel-content__text">
        {{ content }}
      </div>
      <ul v-if="contentList && contentList.length > 0" class="panel-content__list">
        <li v-for="listItem in contentList" :key="listItem">
          <!-- eslint-disable vue/no-v-html -->
          <span v-html="listItem" />
          <!-- eslint-enable vue/no-v-html -->
        </li>
      </ul>
    </div>
  </div>
</template>
